import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { NavEntryPoint } from '@retailer-platform/dashboard/routing'
import { merchandisingAccessControl } from './access-control/merchandisingAccess.configuration'
import { merchandisingScopedRouter } from './routing/merchandisingScopedRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'merchandising',
  totem: {
    // The default IPP tool of all routes in this domain - should match the Navigation Entry in IPP UI.
    // Individual routes can override this by specifying a `tool` prop on their DomainRoute component
    tool: 'merchandising-dashboard-tool',
  },
  routes,
  translations: { EN_US },
  lazyTranslations: {
    ES_ES: () => import('./translations/es-ES.json'),
    FR_FR: () => import('./translations/fr-FR.json'),
  },
  routers: {
    scoped: [merchandisingScopedRouter],
  },
  navigationEntries: [
    {
      attachToV2: NavEntryPoint.Marketing,
      subNavItems: [
        {
          type: 'item',
          llmDescription: 'Create and manage hero banners for storefront homepage',
          labelId: 'merchandising.hero-banners.title',
          route: 'merchandising-hero-banners-list',
          accessControl: merchandisingAccessControl,
          positionNavV2: 3,
        },
      ],
    },
  ],
  adminNavigationEntries: [],
}

export default definition
